export const emptyGuid = '00000000-0000-0000-0000-000000000000'

export const languages = ['en', 'de', 'fr', 'it']

export const emptyString = ''

export const emptyFunc = () => undefined

export const captchaSiteKey = '6Lc7Hg8pAAAAAOicC3NMrHjGI0OY4WnAt_RdncV3'
